import axios from 'axios'
import { NavigateFunction } from 'react-router-dom'
import { loginRedirect } from 'utils/MsGraphApiCall'
const ROTAS_WHITE_LIST = [
  'componentes/micro-frontend/codigo/',
  'plataformas/nome-host/',
  '/usuarios/token?key'
]
const existeRotaNaWhiteList = (url: string): boolean => {
  return ROTAS_WHITE_LIST.some(r => url.includes(r))
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
})

const apiV1 = axios.create({
  baseURL: process.env.REACT_APP_API_URL_V1
})

const setupResponseInterceptor = (navigate: NavigateFunction) => {
  api.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status === 401) {
        loginRedirect()
      } else if (
        error.config.method.toUpperCase() == 'GET' &&
        error.response.status >= 400 &&
        !existeRotaNaWhiteList(error.config.url)
      ) {
        return navigate('/permissao-negada')
      } else {
        return Promise.reject(error)
      }
    }
  )
}

export { api, apiV1, setupResponseInterceptor }
